import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  StepGroup,
  Step,
  StepContent,
  StepTitle,
  StepDescription,
  Label,
  Loader,
  Message,
  Icon,
  Dimmer,
} from "semantic-ui-react";
import CustomerClient from "@common/api/CustomerClient";
import { ComplianceUIDateTimeFormat } from "@common/constants/datetime";
import { handleError } from "@common/components/helpers/error";
import LoadingAction from "@common/redux/actions/LoadingAction";

const formatTimestamp = (iso) =>
  iso ? dayjs(iso).format(ComplianceUIDateTimeFormat) : "";

const History = ({ customerId }) => {
  const [historyItems, setHistoryItems] = useState([]);

  useEffect(() => {
    LoadingAction.set(true).then(() => {
    CustomerClient.ReviewHistory(customerId)
      .then((data) => {
          setHistoryItems(data);
      })
      .catch(handleError)
      .finally(() => LoadingAction.set(false))});
  }, [customerId]);

  return (
    <StepGroup vertical fluid>
      {historyItems.map((entry, index) => (
        <Step key={`${entry.timestamp}-${index}`} completed>
            <Icon name="history" />
            <StepContent className="flex gap-0_25">
              <StepDescription className="flex-left-0_25">
                <Label size="tiny">{entry.type}</Label>
                <span className="align-center">{formatTimestamp(entry.timestamp)}</span>
              </StepDescription>
              {entry.summary ? (
                <StepTitle>{entry.summary}</StepTitle>
              ) : null}
              {entry.user?.name ? (
                <StepDescription>By {entry.user.name}</StepDescription>
              ) : null}
          </StepContent>
        </Step>
      ))}
    </StepGroup>
  );
};

export default History;
